import React from 'react';
import { TypeSpec } from 'src/models/Sidekick/SidekickModuleSpec';
import EnumControl from './EnumControl';
import InputControl from './InputControl';
import HtmlEditor from './HtmlEditor/HtmlEditor';
import { HalfRow } from './Layout';

const StringControl = ({
  'data-aid': dataAid,
  attr,
  description,
  disabled,
  isHtml,
  typeSpec,
}: {
  'data-aid'?: string;
  attr: string;
  description?: string;
  disabled: boolean;
  isHtml?: boolean;
  typeSpec: TypeSpec;
}) => {
  if (typeSpec.enum) {
    return (
      <HalfRow className="asdf">
        <EnumControl attr={attr} data-aid={dataAid} description={description} typeSpec={typeSpec} disabled={disabled} />
      </HalfRow>
    );
  }

  if (typeSpec.name?.endsWith('Copy') || isHtml) {
    return (
      <HtmlEditor
        attr={attr}
        data-aid={dataAid}
        description={description}
        prompt={typeSpec.prompt}
        disabled={disabled}
      />
    );
  }

  return (
    <HalfRow>
      <InputControl attr={attr} data-aid={dataAid} description={description} typeSpec={typeSpec} disabled={disabled} />
    </HalfRow>
  );
};

export default StringControl;
